'use strict';

module.exports = [require('./intersect'), require('./distance')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/geometry/index.js
// module id = 3vN1
// module chunks = 0